import uuidv4 from "./uuidv4";

/**
 * Returns user id from localStorage. If
 * no user id exists, a uuid is assigned.
 *
 * @returns {string}
 */
export default function getUserId() {
  let userId = localStorage.getItem("speakeasy:uid");
  if (!userId) {
    userId = uuidv4();
    localStorage.setItem("speakeasy:uid", userId);
  }
  return userId;
}
